<template>
  <div>
    <v-select
      style="margin-top: 16px;"
      label="name"
      v-model="type"
      :options="productTypes"
    ></v-select>
    <v-menu
      v-model="datePickerMenu"
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field v-model="dateRangeText" label="Date filter" readonly v-on="on"></v-text-field>
      </template>
      <v-date-picker v-model="dates" range></v-date-picker>
    </v-menu>
    <v-row align-content="end">
      <v-col :cols="12" align-self="end">
        <v-spacer></v-spacer>
        <v-btn @click="getSalesReport">Generate</v-btn>
        <v-btn @click="exportreport">Export</v-btn>
      </v-col>
    </v-row>
    <div class="mb-4">
      <v-row>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-cash-multiple
              </v-icon>
              <v-row align="start">
                <div style="text-align:left;">
                  <strong>Total Amount</strong>
                  </br>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(totalAmount || '—').toLocaleString()"
                  ></span>
                  <strong>{{ totalAmount > 1 ? 'Pesos' : 'Peso' }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-cash-remove
              </v-icon>
              <v-row align="start">
                <div style="text-align:left;">
                  <strong>Discount</strong>
                  </br>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(totalDiscount || '—').toLocaleString()"
                  ></span>
                  <strong>{{ totalDiscount > 1 ? 'Pesos' : 'Peso' }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-cash-plus
              </v-icon>
              <v-row align="start">
                <div style="text-align:left;">
                  <strong>Total Receivable</strong>
                  </br>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(totalReceivable || '—').toLocaleString()"
                  ></span>
                  <strong>{{ totalReceivable > 1 ? 'Pesos' : 'Peso' }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-counter
              </v-icon>
              <v-row align="start">
                <div>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(totalTransactions || '—').toLocaleString()"
                  ></span>
                  <strong>{{ totalTransactions > 1 ? 'Transactions' : 'Transaction' }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-account-supervisor
              </v-icon>
              <v-row align="start">
                <div>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(totalCustomers || '—').toLocaleString()"
                  ></span>
                  <strong>{{ totalCustomers > 1 ? 'Customers' : 'Customer' }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col :cols="12" md="4" sm="6" lg="3">
          <v-card class="mx-auto" color="grey lighten-4">
            <v-card-title>
              <v-icon color="indigo" class="mr-12" size="64">
                mdi-ring
              </v-icon>
              <v-row align="start">
                <div>
                  <span
                    class="display-2 font-weight-black"
                    v-text="(totalProductsSold || '—').toLocaleString()"
                  ></span>
                  <strong>{{ totalProductsSold > 1 ? 'Products' : 'Product' }}</strong>
                </div>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-simple-table ref="reporttable">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">Sales ID</th>
            <th class="text-left">Sales date</th>
            <th class="text-left">Customer</th>
            <th class="text-left">Product Name</th>
            <th class="text-left">Product Type</th>
            <th class="text-left">Serial Number</th>
            <th class="text-left">Amount</th>
            <th class="text-left">Discount</th>
            <th class="text-left">Total</th>
            <th class="text-left">Paid Amount</th>
            <th class="text-left">Balance</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="sale in sales">
            <tr :key="sale.id">
              <td class="text-left">{{ sale.id }}</td>
              <td class="text-left">{{ sale.created_at }}</td>
              <td class="text-left">{{ sale.customer.name }}</td>
              <td class="text-left"></td>
              <td class="text-left"></td>
              <td class="text-left"></td>
              <td class="text-left">{{ (sale.amount || 0).toLocaleString() }}</td>
              <td class="text-left">{{ (sale.discount || 0).toLocaleString() }}</td>
              <td class="text-left">{{ (sale.net_amount || 0).toLocaleString() }}</td>
              <td class="text-left">{{ (sale.paid_amount || 0).toLocaleString() }}</td>
              <td class="text-left">{{ (sale.amount_receivable || 0).toLocaleString() }}</td>
            </tr>
            <tr v-for="inventory in sale.inventories" :key="inventory.serial">
              <td class="text-left"></td>
              <td class="text-left"></td>
              <td class="text-left"></td>
              <td class="text-left">
                <span v-if="inventory.set_id != null">({{ inventory.set.name }})</span>
                {{ inventory.product.name }}
              </td>
              <td class="text-left">{{ inventory.product.product_type.name }}</td>
              <td class="text-left">{{ inventory.serial }}</td>
              <td class="text-left">{{ (inventory.amount || 0).toLocaleString() }}</td>
              <td class="text-left">{{ (inventory.discount || 0).toLocaleString() }}</td>
              <td class="text-left">{{ (inventory.net_amount || 0).toLocaleString() }}</td>
              <td class="text-left"></td>
              <td class="text-left"></td>
              <td class="text-left"></td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import vSelect from 'vue-select';
import { mapState, mapActions } from 'vuex';
import XLSX from 'xlsx';

export default {
  computed: {
    ...mapState({
      productTypes(state){
        const products = [
          {
            id: 'all',
            name: 'All products'
          }
        ]
        return products.concat(state.ProductType.plainproductTypes);
      }
    }),
    dateRangeText() {
      return this.dates.join(' ~ ');
    },
    totalAmount() {
      if (this.sales.length == 0) {
        return false;
      }
      let amount = 0;
      this.sales.forEach(sale => {
        amount += sale.net_amount;
      });
      return amount;
    },
    totalDiscount() {
      if (this.sales.length == 0) {
        return false;
      }
      let discount = 0;
      this.sales.forEach(sale => {
        discount += sale.discount;
      });
      return discount;
    },
    totalReceivable() {
      if (this.sales.length == 0) {
        return false;
      }
      let amount = 0;
      this.sales.forEach(sale => {
        if (!isNaN(sale.amount_receivable)) {
          amount += sale.amount_receivable;
        }
      });
      return amount;
    },
    totalTransactions() {
      if (this.sales.length == 0) {
        return false;
      }
      return this.sales.length;
    },
    totalCustomers() {
      if (this.sales.length == 0) {
        return false;
      }
      let customers = [];
      this.sales.forEach(sale => {
        customers.push(sale.customer.id);
      });
      return customers.filter((item, index) => customers.indexOf(item) === index).length;
    },
    totalProductsSold() {
      if (this.sales.length == 0) {
        return false;
      }
      let total = 0;
      this.sales.forEach(sale => {
        total += sale.inventories.length;
      });
      return total;
    }
  },
  mounted() {
    this['ProductType/fetchProductTypes']({ dontPaginate: false });
  },
  methods: {
    ...mapActions(['ProductType/fetchProductTypes']),
    getSalesReport() {
      if (this.dates.length == 2) {
        const params = {
          date: this.dates,
          type: typeof this.type.id != 'undefined' ? this.type.id : ''
        };
        axios.get('api/v1/sale/report', { params: params }).then(response => {
          this.sales = response.data.data;
        });
      } else {
        this.$store.commit('SET_SNACK_BAR', {
          message: 'Please set date range before generating report...',
          color: 'error'
        });
      }
    },
    exportreport() {
      const table = this.$refs.reporttable.$el;
      const wb = XLSX.utils.table_to_book(table, { raw: true });
      XLSX.writeFile(wb, 'sheetjs.xlsx');
    }
  },
  components: {
    vSelect
  },
  data: function() {
    return {
      datePickerMenu: false,
      dates: [],
      type: '', //include all option
      sales: []
    };
  }
};
</script>
